// import qs from 'qs';
import axios from "axios";
import { showNotify } from "vant";
import "vant/es/notify/style";
import router from "../router";
let https = 'https://front.api.huanyouhudong.com';//线上
// let https = 'http://192.168.1.14:2000';//本地
// let https = 'http://xhtest.iepose.cn';//穿透
// let https = 'https://fywlkj12.free.idcfengye.com';
// let https = 'http://localhost:2000';
const http = axios.create({
  timeout: 30000,
  withCredentials: true,
});
/* 
  *相应拦截器
   用于处理成功回调，相应错误处理
*/
http.interceptors.request.use(
  (config) => {
    // console.log(config)
    if (config.url.indexOf('/common/v1/order/query') != -1) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    if (localStorage.getItem("offUserToken")) {
      config.headers['appVersion'] = '1.1.4';//线上实时版本号(不是强制更新号)
      config.headers['sourceType'] = localStorage.getItem("sourceType");//环境(1-微信中html5,2-苹果主屏幕模式,3-安卓app)
      config.headers['deviceType'] = localStorage.getItem("deviceType");//设备类型
      config.headers['offUserToken'] = localStorage.getItem("offUserToken");
      config.headers['offUserId'] = localStorage.getItem("offUserId");
      config.headers['gameUserToken'] = localStorage.getItem("gameUserToken");
      config.headers['gameUserId'] = localStorage.getItem("gameUserId");
    } else {
      config.headers['appVersion'] = '1.1.4';//线上实时版本号(不是强制更新号)
      config.headers['sourceType'] = localStorage.getItem("sourceType");//环境(1-微信中html5,2-苹果主屏幕模式,3-安卓app)
      config.headers['deviceType'] = localStorage.getItem("deviceType");//设备类型
    }
    return config;
  },
  (error) => Promise.reject(error)
);
http.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      if (response.data.status == 13 || response.data.status == 14) {
        localStorage.removeItem("gameUserToken");
        localStorage.removeItem("gameUserId");
        localStorage.removeItem("offUserToken");
        localStorage.removeItem("offUserId");
        showNotify({
          type: "warning",
          message: "Token 无效，请重新登录",
          duration: 2 * 1000,
        });
        const timerId = setTimeout(() => {
          router.push({ path: "/H5/homeOpen" }); // 跳转登录页
        }, 1000); // 1000毫秒 = 1秒
      }
      return response.data;
    } else {
      return Promise.reject(response);
    }
  },
  (err) => {
    showNotify({
      message: err.message || "error",
      type: "warning",
      duration: 5 * 1000,
    });
    return Promise.reject(err);
  }
);

export const request = (url, params, stringify = true, type = "post") => {
  if (type == "post") {
    return http.post(https + url, params, { stringify });
  } else {
    // console.log(type, params);
    return http.get(https + url, params, { stringify });
  }
};
